// extracted by mini-css-extract-plugin
export default {"note":"Note_note__3ofXz","header":"Note_header__MBmZm","content":"Note_content__2Tv3Y","mark":"Note_mark__3B4qP","resolved":"Note_resolved__1T0K2","open":"Note_open__J_8xC"};